import { Component, Input, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import packageInfo from '../../../../package.json';

@Component({
  selector: 'app-version-modal',
  templateUrl: './version-modal.component.html',
  styleUrls: ['./version-modal.component.css']
})
export class VersionModalComponent implements OnInit {
  version: string = packageInfo.version;
  language: string;

  @Input() modalRef: NgbModalRef;

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(){
    this.language = this.translate.getDefaultLang();
  }

  close(){
    this.modalRef.close();
  }

}
